const pad = (n: number) => String(n).padStart(2, '0');

/** Local date as yyyy-mm-dd, the format of date filters and fields. */
export const toDateValue = (date: Date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
